module.exports = __webpack_public_path__ + "img/hs.e76e0f26.png";